// ─────────────────────────────────────────────────────────────
// BGP Cart Bundle Nudge — v2
// Shows a "build your own bundle" nudge in the cart drawer
// and cart page ONLY when no RumiAMM BYOB bundle is in cart.
// Detection: checks _rumi_byob_bundle_id line item property
// set automatically by the RumiAMM app on every bundle item.
// No handle lists or tag checks needed — scales automatically.
// ─────────────────────────────────────────────────────────────

// ── Styles ───────────────────────────────────────────────────
function injectNudgeStyles() {
  if (document.getElementById('bundle-nudge-styles')) return;

  const style = document.createElement('style');
  style.id = 'bundle-nudge-styles';
  style.textContent = `
    @keyframes nudge-slideup {
      0%   { opacity: 0; transform: translateY(20px) scale(0.97); }
      60%  { opacity: 1; transform: translateY(-4px) scale(1.01); }
      100% { opacity: 1; transform: translateY(0) scale(1); }
    }

    @keyframes nudge-shake {
      0%, 100% { transform: translateX(0); }
      15%       { transform: translateX(-6px); }
      30%       { transform: translateX(6px); }
      45%       { transform: translateX(-4px); }
      60%       { transform: translateX(4px); }
      75%       { transform: translateX(-2px); }
      90%       { transform: translateX(2px); }
    }

    @keyframes nudge-glow {
      0%, 100% {
        box-shadow: 0 0 0px 0px rgba(200, 169, 110, 0);
        border-color: #c8a96e;
      }
      50% {
        box-shadow: 0 0 18px 4px rgba(200, 169, 110, 0.45),
                    inset 0 0 12px 0px rgba(200, 169, 110, 0.12);
        border-color: #e8c97e;
      }
    }

    /* Drawer nudge */
    .side-cart-bundle-nudge {
      display: none;
      padding: 14px 18px;
      background: linear-gradient(135deg, #fdf6ec 0%, #fff9f0 100%);
      border-left: 3px solid #c8a96e;
      margin: 12px 16px;
      border-radius: 6px;
      font-size: 0.875rem;
      line-height: 1.6;
    }

    .side-cart-bundle-nudge.is-entering {
      animation: nudge-slideup 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    }

    .side-cart-bundle-nudge.is-shaking {
      animation: nudge-shake 0.45s ease forwards, nudge-glow 0.45s ease forwards;
    }

    /* Cart page nudge */
    .bundle-nudge-cart {
      padding: 14px 18px;
      background: linear-gradient(135deg, #fdf6ec 0%, #fff9f0 100%);
      border-left: 3px solid #c8a96e;
      margin: 16px 0;
      border-radius: 6px;
      font-size: 0.875rem;
      line-height: 1.6;
    }

    .bundle-nudge-cart.is-entering {
      animation: nudge-slideup 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    }

    .bundle-nudge-cart.is-shaking {
      animation: nudge-shake 0.45s ease forwards, nudge-glow 0.45s ease forwards;
    }

    .side-cart-bundle-nudge a:hover,
    .bundle-nudge-cart a:hover {
      opacity: 0.8;
      text-decoration: none !important;
    }
  `;
  document.head.appendChild(style);
}

// ── Shake loop ───────────────────────────────────────────────
const shakeIntervals = new WeakMap();

function startShakeLoop(nudge) {
  if (shakeIntervals.has(nudge)) clearInterval(shakeIntervals.get(nudge));

  const interval = setInterval(() => {
    if (!document.contains(nudge) || nudge.style.display === 'none') {
      clearInterval(interval);
      return;
    }
    nudge.classList.remove('is-shaking');
    void nudge.offsetWidth; // force reflow to restart animation
    nudge.classList.add('is-shaking');
    setTimeout(() => nudge.classList.remove('is-shaking'), 500);
  }, 2000);

  shakeIntervals.set(nudge, interval);
}

function stopShakeLoop(nudge) {
  if (shakeIntervals.has(nudge)) {
    clearInterval(shakeIntervals.get(nudge));
    shakeIntervals.delete(nudge);
  }
}

// ── Drawer: show / hide ──────────────────────────────────────
function showDrawerNudge(nudge) {
  nudge.style.display = 'block';
  nudge.style.opacity = '0';
  nudge.classList.remove('is-entering', 'is-shaking');
  stopShakeLoop(nudge);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      nudge.style.opacity = '';
      nudge.classList.add('is-entering');
      nudge.addEventListener('animationend', () => {
        nudge.classList.remove('is-entering');
        startShakeLoop(nudge);
      }, { once: true });
    });
  });
}

function hideDrawerNudge(nudge) {
  nudge.style.display = 'none';
  stopShakeLoop(nudge);
}

// ── Drawer: inject HTML (once only) ─────────────────────────
function injectDrawerNudge(container) {
  if (container.querySelector('.side-cart-bundle-nudge')) return false;

  const nudge = document.createElement('div');
  nudge.className = 'side-cart-bundle-nudge';
  nudge.innerHTML = `
    <span style="display:block; font-weight:700; margin-bottom:2px; font-size:0.9rem;">
      🎁 You're missing out on bundle savings!
    </span>
    <span style="opacity:0.85;">
      Why buy single when you can
      <a href="/collections/burmans-gun-podi"
         style="color:#c8a96e; font-weight:700; text-decoration:underline; white-space:nowrap;">
        build your own spice bundle
      </a> and save more?
    </span>
  `;

  const summary = container.querySelector('.cart-drawer__summary');
  if (summary) {
    summary.parentNode.insertBefore(nudge, summary);
    return true;
  }
  return false;
}

// ── Cart page: animate only, Liquid controls visibility ──────
function initCartPageNudge() {
  const nudge = document.querySelector('.bundle-nudge-cart');
  if (!nudge) return;

  nudge.classList.add('is-entering');
  nudge.addEventListener('animationend', () => {
    nudge.classList.remove('is-entering');
    startShakeLoop(nudge);
  }, { once: true });
}

// ── Core check: fetch cart and decide ───────────────────────
function checkAndShowBundleNudge() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {

      // Detect any RumiAMM BYOB bundle in cart via line item property.
      // _rumi_byob_bundle_id is stamped automatically by the app
      // on every bundle item — works for all current & future bundles.
      const hasBundle = cart.items.some(item =>
        item.properties && item.properties['_rumi_byob_bundle_id']
      );

      const cartDrawer = document.querySelector('#cart-drawer');
      if (!cartDrawer) return;

      injectDrawerNudge(cartDrawer);
      const nudge = cartDrawer.querySelector('.side-cart-bundle-nudge');
      if (!nudge) return;

      hasBundle ? hideDrawerNudge(nudge) : showDrawerNudge(nudge);
    })
    .catch(err => console.warn('[BGP Nudge] Cart fetch failed:', err));
}

// ── MutationObserver: re-check on drawer re-renders ─────────
function observeCartDrawer() {
  const cartDrawer = document.querySelector('#cart-drawer');
  if (!cartDrawer) return;

  let debounceTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkAndShowBundleNudge, 80);
  });

  observer.observe(cartDrawer, { childList: true, subtree: true });
}

// ── Init ─────────────────────────────────────────────────────
injectNudgeStyles();

document.addEventListener('theme-drawer:open', (e) => {
  if (e.target && e.target.id === 'cart-drawer') {
    checkAndShowBundleNudge();
  }
});

document.addEventListener('shopify:cart:lines-update', checkAndShowBundleNudge);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observeCartDrawer();
    initCartPageNudge();
  });
} else {
  observeCartDrawer();
  initCartPageNudge();
}
